module.exports = __webpack_public_path__ + "img/frame.49081d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/blockChain/frame.png
// module id = JHDv
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37